import React, { Children, isValidElement, useMemo } from 'react';
import s from './group.module.css';
import { context } from './utils';
var Group = function Group(_ref) {
  var children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? [] : _ref$width,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? [] : _ref$maxWidth;
  var prepared = useMemo(function () {
    var filteredChildren = Children.toArray(children).filter(Boolean);
    var amount = filteredChildren.length;
    return filteredChildren.reduce(function (acc, child) {
      if (!isValidElement(child)) {
        acc.push(child);
        return acc;
      }
      var isFragment = child.type === React.Fragment;
      var fragmentChildren = isFragment && Array.isArray(child.props.children) && child.props.children.filter(Boolean);
      if (isFragment && fragmentChildren && fragmentChildren.length <= 0) {
        return;
      }
      if (fragmentChildren) {
        amount += fragmentChildren.length - 1;
      }
      (fragmentChildren || [child]).forEach(function (flatChild) {
        var idx = acc === null || acc === void 0 ? void 0 : acc.length;
        acc.push(React.createElement(context.Provider, {
          key: idx,
          value: {
            size: size,
            index: idx,
            width: typeof width[idx] !== 'undefined' ? width[idx] : '1',
            maxWidth: maxWidth[idx],
            first: idx === 0,
            last: idx === amount - 1
          }
        }, flatChild));
      });
      return acc;
    }, []);
  }, [children, size, width, maxWidth]);
  return React.createElement("div", {
    className: s.container,
    "data-ui-group": true
  }, prepared);
};
export default Group;